import { UserAgentApplication } from 'msal'
import config from 'config'

const CLIENT_ID_REGEX = /[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/
const loginRequest = {
	scopes: ['openid', 'email'],
}
let msalInstance

const getUserAgentApp = (clientId, redirectUri) => {
	if (clientId && CLIENT_ID_REGEX.test(clientId)) {
		return new UserAgentApplication({
			auth: {
				...(redirectUri && { redirectUri }),
				clientId,
				validateAuthority: true,
				navigateToLoginRequestUrl: false,
			},
		})
	}
}

const getMsalInstance = () => {
	if (!msalInstance && config.office365) {
		msalInstance = getUserAgentApp(config.office365.clientId, config.office365.callback)
	}
	return msalInstance
}

const popupLogin = (successCallback, failureCallback, isOfflineMode) => {
	msalInstance
		.loginPopup(loginRequest)
		.then(response => {
			if (response.idToken) {
				let responseData
				if (isOfflineMode) {
					responseData = {
						name: response.idTokenClaims.name,
						email: response.idTokenClaims.email,
					}
				} else {
					responseData = {
						id_token: response.idToken.rawIdToken,
					}
				}
				successCallback(responseData)
			}
		})
		.catch(error => {
			failureCallback(error)
		})
}

const loginWithOffice365 = (successCallback, failureCallback, isOfflineMode) => {
	if (msalInstance) {
		popupLogin(
			successCallback,
			failureCallback,
			isOfflineMode
		)
	}
}

export {
	getMsalInstance,
	loginWithOffice365,
}
